import React from "react";
import SafeSiteImage from "./SafeSiteImage";
import styled, { css } from "styled-components";
import Container from "./Container";
import Title from "./Title";
import Section from "./Section";
import { HtmlContent } from "./Content";

const ContentLandingPageStyles = styled.div`
  ${({ ...props }) => css`
    .section {
      ${props.$onlyTitle ? 'padding-bottom: 0;' : ''}
    }

    .container {
      text-align: ${props.$align};
    }

    .content {
      margin-top: .5rem
    }

    .contentLandingPage-images {
      margin-top: 3rem;
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(100px, 1fr));
      gap: 32px;
      justify-items: center;
    }

    .figure {
      max-width: 200px
    }

    .figure img {
      width: 100%;
      height: auto;
      aspect-ratio: 1;
      object-fit: contain;
      border-radius: 4px
    }

    .figure figcaption {
      margin-top: .5rem
    }

    a {
      color: ${props.theme.colors.primary};
      text-decoration: underline;
      display: inline-block;

      &:hover {
        color: ${props.theme.colors.darkPrimary};
      }
    }
  `}
`;

export const ContentLandingPage = ({ title, content, background, images, align = 'center' }) => {
  const onlyTitle = !content && (!images || images.length === 0)
  return (
    <ContentLandingPageStyles
      $align={align}
      $onlyTitle={onlyTitle}
    >
      <Section grey={background === "grey"} className="section">
        <Container slim className="container">
          <Title title={title} classes="heading" />
          {content && <div className="content"><HtmlContent htmlString={content} /></div>}
          {images && images.length > 0 && (
            <div className="contentLandingPage-images">
              {images.map((image, index) => {
                if (!image.image.mediaItemUrl) {
                  return;
                }
                return (
                  <figure className="figure" key={`${image.label} + ${index}`}>
                    <SafeSiteImage
                      image={image.image.mediaItemUrl}
                      alt={image.image.altText ? image.image.altText : image.label}
                      width="256"
                      height="256"
                    />
                    {image.label && <figcaption><HtmlContent htmlString={image.label} /></figcaption>}
                  </figure>
                )
              })}
            </div>
          )}
        </Container>
      </Section>
    </ContentLandingPageStyles>
  );
};
